import Main from '_c/main/main'
import Login from '_c/login'

export default [
  {
    path: '/',
    redirect: '/login',
    component: Login,
    children: [
      {
        path: '/login',
        name: 'Login',
        meta: {
          title: '登录',
          hideInMenu: true,
          notCache: true
        },
        component: Login
      }
    ]
  },
  {
    path: '/home',
    redirect: '/home',
    component: Main,
    meta: {
      hideInMenu: true,
      notCache: true
    },
    children: [
      {
        path: '/home',
        name: 'Home',
        meta: {
          hideInMenu: true,
          title: '首页',
          icon: 'shouyeguanli'
        },
        component: () => import('_c/home/home')
      }
    ]
  },
  {
    path: '/indexmanage',
    name: 'Indexmanage',
    redirect: '/indexmanage/banner',
    meta: {
      title: '首页管理',
      icon: 'shouyeguanli'
    },
    component: Main,
    children: [
      {
        path: 'setindextemplate',
        name: 'SetIndexTemplate',
        meta: {
          title: '首页模板',
          icon: 'banner1'
        },
        component: () => import('_c/indexmanage/setindextemplate')
      },
      {
        path: 'banner',
        name: 'Banner',
        meta: {
          title: '首页轮播图',
          icon: 'banner1'
        },
        component: () => import('_c/indexmanage/banner')
      },
      {
        path: '/indexmanage/indexicon',
        name: 'IndexIcon',
        meta: {
          title: '图标按钮',
          icon: 'tubiao'
        },
        component: () => import('_c/indexmanage/indexicon')
      },
      {
        path: '/indexmanage/indexadver',
        name: 'IndexAdver',
        meta: {
          title: '第二广告位',
          icon: 'banner2'
        },
        component: () => import('_c/indexmanage/indexadver')
      },
      {
        path: '/indexmanage/goodsscroll',
        name: 'GoodsScroll',
        meta: {
          title: '横向滚动商品',
          icon: 'hengxianggundong'
        },
        component: () => import('_c/indexmanage/goodsscroll')
      },
      {
        path: '/indexmanage/finegoods',
        name: 'FineGoods',
        meta: {
          title: '精选商品',
          icon: 'tab_jingxuanshangpin_icon'
        },
        component: () => import('_c/indexmanage/finegoods')
      },
      {
        path: '/indexmanage/indexcase',
        name: 'IndexCase',
        meta: {
          title: '精选案例',
          icon: 'iconfuzhi'
        },
        component: () => import('_c/indexmanage/indexcase')
      },
      {
        path: '/indexmanage/offlineactivity',
        name: 'OfflineActivity',
        meta: {
          title: '线下活动',
          icon: 'iconfuzhi'
        },
        component: () => import('_c/indexmanage/offlineactivity')
      },
      {
        path: '/indexmanage/bottombanner',
        name: 'BottomBanner',
        meta: {
          title: '底部广告',
          icon: 'iconfuzhi'
        },
        component: () => import('_c/indexmanage/bottombanner')
      },
      {
        path: '/indexmanage/Finecoupon',
        name: 'Finecoupon',
        meta: {
          title: '精选优惠券',
          icon: 'iconfuzhi'
        },
        component: () => import('_c/indexmanage/Finecoupon')
      },
      {
        path: '/indexmanage/Finegroupbuy',
        name: 'Finegroupbuy',
        meta: {
          title: '精选拼团',
          icon: 'iconfuzhi'
        },
        component: () => import('_c/indexmanage/Finegroupbuy')
      },
      {
        path: '/indexmanage/Fineseckill',
        name: 'Fineseckill',
        meta: {
          title: '精选秒杀',
          icon: 'iconfuzhi'
        },
        component: () => import('_c/indexmanage/Fineseckill')
      }
    ]
  },
  {
    path: '/contentmanage',
    name: 'Content',
    redirect: '/contentmanage/hospitalInfo',
    meta: {
      title: '内容管理',
      icon: 'neirongguanli'
    },
    component: Main,
    children: [
      {
        path: '/contentmanage/hospitalInfo',
        name: 'HospitalInfo',
        meta: {
          title: '医院信息',
          icon: 'yiyuan'
        },
        component: () => import('_c/contentmanage/hospitalinfo')
      },
      {
        path: '/contentmanage/expertdetail',
        name: 'Expertdetail',
        meta: {
          title: route =>
            '专家信息-' +
            (`${route.query.specialistId}` ? `${route.query.name}` : '添加'),
          icon: 'mingpian'
        },
        component: () => import('_c/contentmanage/expertdetail')
      },
      {
        path: '/contentmanage/expertlist',
        name: 'Expertlist',
        meta: {
          title: '专家信息列表',
          icon: 'mingpian'
        },
        component: () => import('_c/contentmanage/expertlist')
      },
      {
        path: '/contentmanage/casetype',
        name: 'CaseType',
        meta: {
          title: '案例分类',
          icon: 'anlifenlei'
        },
        component: () => import('_c/contentmanage/casetype')
      },
      {
        path: '/contentmanage/caselist',
        name: 'CaseList',
        meta: {
          title: '案例管理',
          icon: 'anli'
        },
        component: () => import('_c/contentmanage/caselist')
      },
      {
        path: '/contentmanage/casedetail',
        name: 'CaseDetail',
        meta: {
          title: '案例详情',
          isDetail: 'CaseList'
        },
        component: () => import('_c/contentmanage/casedetail')
      },
      {
        path: '/contentmanage/articlelist',
        name: 'ArticleList',
        meta: {
          title: '资讯管理',
          icon: 'zixun'
        },
        component: () => import('_c/contentmanage/articlelist')
      },
      {
        path: '/contentmanage/articleCat',
        name: 'ArticleCat',
        meta: {
          title: '资讯分类',
          icon: 'zixun'
        },
        component: () => import('_c/contentmanage/articleCat')
      },
      {
        path: '/contentmanage/articledetail',
        name: 'ArticleDetail',
        meta: {
          title: '资讯详情',
          isDetail: 'ArticleList'
        },
        component: () => import('_c/contentmanage/articledetail')
      },
      {
        path: '/contentmanage/empcardlist',
        name: 'EmpCardList',
        meta: {
          title: '名片管理',
          icon: 'mingpian'
        },
        component: () => import('_c/contentmanage/empcardlist')
      },
      {
        path: '/contentmanage/empcarddetail',
        name: 'EmpCardDetail',
        meta: {
          title: '名片详情',
          isDetail: 'EmpCardList'
        },
        component: () => import('_c/contentmanage/empcarddetail')
      },

      {
        path: '/contentmanage/empcard_footprint',
        name: 'EmpCardFootprint',
        meta: {
          title: route => '足迹-' + `${route.query.name}`,
          isDetail: 'EmpCardList',
          icon: 'zujiliebiao'
        },
        component: () => import('_c/contentmanage/emp_card_footprint')
      },
      {
        path: '/contentmanage/empcard_intention_cus',
        name: 'EmpCardIntentionCus',
        meta: {
          title: route => '意向客户-' + `${route.query.name}`,
          isDetail: 'EmpCardList',
          icon: 'yixiangkehuliebiao'
        },
        component: () => import('_c/contentmanage/emp_card_intention_cus')
      },
      {
        path: '/contentmanage/storeBrand',
        name: 'StoreBrand',
        meta: {
          title: '品牌管理',
          icon: 'shangpinfenlei'
        },
        component: () => import('_c/contentmanage/storeBrand')
      },
      {
        path: '/contentmanage/hotSearchWord',
        name: 'HotSearchWord',
        meta: {
          title: '热门搜索词',
          icon: 'shangpinfenlei'
        },
        component: () => import('_c/contentmanage/hotSearchWord')
      },
      {
        path: '/contentmanage/lable',
        name: 'Lable',
        meta: {
          title: '标签管理',
          icon: 'piliangcaozuo'
        },
        component: () => import('_c/contentmanage/lable')
      },
      {
        path: '/contentmanage/pictureLibrary',
        name: 'PictureLibrary',
        meta: {
          title: '图片库管理',
          icon: 'shangpinfenlei'
        },
        component: () => import('_c/contentmanage/pictureLibrary')
      },
      {
        path: '/contentmanage/ItemCat',
        name: 'ItemCat',
        meta: {
          title: '项目分类',
          icon: 'anlifenlei'
        },
        component: () => import('_c/contentmanage/ItemCat')
      },
      {
        path: '/contentmanage/EvaluationResult',
        name: 'EvaluationResult',
        meta: {
          title: '评价反馈',
          icon: 'jiaoyimingxi'
        },
        component: () => import('_c/contentmanage/EvaluationResult')
      },
      {
        path: '/contentmanage/PreviewInfo',
        name: 'PreviewInfo',
        meta: {
          title: '预检登记',
          icon: 'jiaoyimingxi'
        },
        component: () => import('_c/contentmanage/PreviewInfo')
      }, {
        path: '/contentmanage/PreviewInfoEmployee',
        name: 'PreviewInfoEmployee',
        meta: {
          title: '员工健康记录',
          icon: 'jiaoyimingxi'
        },
        component: () => import('_c/contentmanage/PreviewInfoEmployee')
      },
      {
        path: '/contentmanage/PreviewInfoBreak',
        name: 'PreviewInfoBreak',
        meta: {
          title: '线上预约',
          icon: 'jiaoyimingxi'
        },
        component: () => import('_c/tempAppointment/')
      }
    ]
  },
  {
    path: '/powermanage',
    name: 'Powermanage',
    meta: {
      title: '权限管理',
      icon: 'kehuguanli'
    },
    component: Main,
    children: [
      {
        path: '/powermanage/employeelist',
        name: 'EmployeeList',
        meta: {
          title: '管理员管理',
          icon: 'staff'
        },
        component: () => import('_c/powermanage/employeelist')
      },
      {
        path: '/powermanage/employeedetail',
        name: 'EmployeeDetail',
        meta: {
          title: '管理员详情',
          isDetail: 'EmployeeList'
        },
        component: () => import('_c/powermanage/employeedetail')
      },
      {
        path: '/powermanage/powerlist',
        name: 'PowerList',
        meta: {
          title: '权限组管理',
          icon: 'shezhi'
        },
        component: () => import('_c/powermanage/powerlist')
      },
      {
        path: '/powermanage/powerdetail',
        name: 'PowerDetail',
        meta: {
          title: '权限组详情',
          isDetail: 'PowerList'
        },
        component: () => import('_c/powermanage/powerdetail')
      }
    ]
  },
  {
    path: '/goodsmanage',
    name: 'Goodsmanage',
    meta: {
      title: '商品管理',
      icon: ''
    },
    component: Main,
    children: [
      {
        path: 'goodscate',
        name: 'GoodsCate',
        meta: {
          title: '商品分类',
          icon: 'shangpinfenlei'
        },
        component: () => import('_c/goodsmanage/goodscate')
      },
      {
        path: '/goodsmanage/goodslist',
        name: 'GoodsList',
        meta: {
          title: '商品管理',
          icon: 'shangpinguanli'
        },
        component: () => import('_c/goodsmanage/goodslist')
      },
      {
        path: '/goodsmanage/ymgooslist',
        name: 'GoodsListYm',
        meta: {
          title: '医脉商品列表',
          icon: 'shangpinfenlei'
        },
        component: () => import('_c/goodsmanage/ymgooslist')
      },
      {
        path: '/goodsmanage/goodsdetail',
        name: 'GoodsDetail',
        meta: {
          title: '商品详情',
          isDetail: 'GoodsList'
        },
        component: () => import('_c/goodsmanage/goodsdetail')
      },
      {
        path: '/goodsmanage/goodspointdetail',
        name: 'GoodspointDetail',
        meta: {
          title: '积分商品详情',
          isDetail: 'GoodsList'
        },
        component: () => import('_c/goodsmanage/goodspointdetail')
      }
    ]
  },
  {
    path: '/ordermanage',
    name: 'Ordermanage',
    meta: {
      title: '订单管理',
      icon: 'dingdan'
    },
    component: Main,
    children: [
      {
        path: '/ordermanage/orderlist',
        name: 'OrderList',
        meta: {
          title: '订单',
          icon: 'hexiao'
        },
        component: () => import('_c/ordermanage/orderlist')
      },
      {
        path: '/ordermanage/orderpointlist',
        name: 'OrderpointList',
        meta: {
          title: '积分订单',
          icon: 'jifendingdan'
        },
        component: () => import('_c/ordermanage/orderpointlist')
      },
      {
        path: '/ordermanage/ymOrderlist',
        name: 'YmOrderList',
        meta: {
          title: '医脉订单',
          icon: 'jifendingdan'
        },
        component: () => import('_c/ordermanage/ymOrderlist')
      }
    ]
  },
  {
    path: '/cusmanage',
    name: 'Cusmanage',
    meta: {
      title: '客户管理',
      icon: 'kehuguanli'
    },
    component: Main,
    children: [
      {
        path: '/cusmanage/customerlist',
        name: 'CustomerList',
        meta: {
          title: '客户信息',
          icon: 'kehuxinxi'
        },
        component: () => import('_c/cusmanage/customerlist')
      },
      {
        path: '/cusmanage/customerdetail',
        name: 'CustomerDetail',
        meta: {
          title: '客户余额变动',
          isDetail: 'CustomerList'
        },
        component: () => import('_c/cusmanage/customerdetail')
      },
      {
        path: '/cusmanage/cuspointdetail',
        name: 'CusPointDetail',
        meta: {
          title: route => '客户积分变动-' + `${route.query.name}`,
          isDetail: 'CustomerList'
        },
        component: () => import('_c/cusmanage/cuspointdetail')
      },
      {
        path: '/cusmanage/customer_bind',
        name: 'CustomerBindList',
        meta: {
          title: '客户绑定列表',
          icon: 'kehubangdingliebiao'
        },
        component: () => import('_c/cusmanage/customer_bind')
      },
      {
        path: '/cusmanage/customer_share',
        name: 'CustomerShare',
        meta: {
          title: '客户管理',
          icon: 'renwuguanli'
        },
        component: () => import('_c/cusmanage/customer_share')
      },
      {
        path: '/cusmanage/customer_footprint',
        name: 'CustomerFootprint',
        meta: {
          title: '足迹',
          icon: 'editionlist'
        },
        component: () => import('_c/cusmanage/customer_footprint')
      },
      {
        path: '/cusmanage/footprint_details',
        name: 'FootprintDetails',
        meta: {
          title: '详情',
          icon: 'kehubangdingliebiao'
        },
        component: () => import('_c/cusmanage/footprint_details')
      },
      {
        path: '/cusmanage/footprintDetails',
        name: 'FootprintDetails2',
        meta: {
          title: '轨迹详情',
          icon: 'kehubangdingliebiao'
        },
        component: () => import('_c/cusmanage/footprintDetails')
      },
      {
        path: '/cusmanage/userGrade',
        name: 'userGrade',
        meta: {
          title: '会员等级',
          icon: 'kehubangdingliebiao'
        },
        component: () => import('_c/cusmanage/userGrade')
      },
      {
        path: '/cusmanage/userGradeSet',
        name: 'userGradeSet',
        meta: {
          title: '会员等级',
          icon: 'kehubangdingliebiao',
          isDetail: 'userGrade'
        },
        component: () => import('_c/cusmanage/userGradeSet')
      },
      {
        path: '/cusmanage/userRight',
        name: 'userRight',
        meta: {
          title: '会员权益',
          icon: 'kehubangdingliebiao'
        },
        component: () => import('_c/cusmanage/userRight')
      },
      {
        path: '/cusmanage/customerproject',
        name: 'CouponProjectUserGoods',
        meta: {
          title: '会员商品',
          icon: 'kehubangdingliebiao'
        },
        component: () => import('_c/cusmanage/customer_project')
      }
    ]
  },
  {
    path: '/coupon',
    name: 'Coupon',
    meta: {
      title: '优惠券管理',
      icon: 'youhuiquan'
    },
    component: Main,
    children: [
      {
        path: '/coupon/couponlist',
        name: 'CouponList',
        meta: {
          title: '优惠券列表',
          icon: 'youhuiquan01'
        },
        component: () => import('_c/coupon/couponlist')
      },
      {
        path: 'couponset',
        name: 'CouponSet',
        meta: {
          title: route =>
            `${route.query.status}` === '0' ? '优惠券添加' : '优惠券编辑',
          isDetail: 'CouponList'
        },
        component: () => import('_c/coupon/couponset')
      },
      {
        path: '/coupon/coupondetail',
        name: 'CouponDetail',
        meta: {
          title: '优惠券明细',
          icon: 'jiaoyimingxi'
        },
        component: () => import('_c/coupon/coupondetail')
      },
      {
        path: '/coupon/couponbatch',
        name: 'CouponBatch',
        meta: {
          title: '批量发券',
          icon: 'piliangcaozuo'
        },
        component: () => import('_c/coupon/couponbatch')
      },
      {
        path: '/coupon/couponProject',
        name: 'CouponProject',
        meta: {
          title: '项目券管理',
          icon: 'piliangcaozuo'
        },
        component: () => import('_c/couponProject/couponProject')
      },
      {
        path: '/coupon/couponProjectSet',
        name: 'CouponProjectSet',
        meta: {
          title: '项目券管理',
          icon: 'piliangcaozuo'
        },
        component: () => import('_c/couponProject/couponProjectSet')
      },
      {
        path: '/coupon/couponProjectDetail',
        name: 'CouponProjectDetail',
        meta: {
          title: '项目券领取详情',
          icon: 'piliangcaozuo'
        },
        component: () => import('_c/couponProject/couponProjectDetail')
      },
      {
        path: '/coupon/couponprojectbatch',
        name: 'CouponProjectBatch',
        meta: {
          title: '批量发项目券',
          icon: 'piliangcaozuo'
        },
        component: () => import('_c/coupon/couponprojectbatch')
      }
    ]
  },
  {
    path: '/saleactivity',
    name: 'Saleactivity',
    meta: {
      title: '秒杀管理',
      icon: 'miaosha'
    },
    component: Main,
    children: [
      {
        path: '/saleactivity/saleactivitylist',
        name: 'SaleActivityList',
        meta: {
          title: '秒杀列表',
          icon: 'liebiao'
        },
        component: () => import('_c/saleactivity/saleactivitylist')
      },
      {
        path: '/saleactivity/saleactivitydetail',
        name: 'SaleActivityDetail',
        meta: {
          title: '新增秒杀活动',
          isDetail: 'SaleActivityList'
        },
        component: () => import('_c/saleactivity/saleactivitydetail')
      },
      {
        path: '/saleactivity/salerecord',
        name: 'SaleRecord',
        meta: {
          title: '秒杀购买记录',
          icon: 'goumaijilu'
        },
        component: () => import('_c/saleactivity/salerecord')
      }
    ]
  },
  {
    path: 'firstorder',
    name: 'FirstOrder',
    meta: {
      title: '首单优惠管理',
      icon: 'shoudan'
    },
    component: Main,
    children: [
      {
        path: '/firstorder/firstorderlist',
        name: 'FirstOrderList',
        meta: {
          title: '首单优惠列表',
          icon: 'liebiao'
        },
        component: () => import('_c/firstorder/firstorderlist')
      },
      {
        path: '/firstorder/firstorderdetail',
        name: 'FirstOrderDetail',
        meta: {
          title: '新增首单活动',
          isDetail: 'FirstorderDetail'
        },
        component: () => import('_c/firstorder/firstorderdetail')
      },
      {
        path: '/firstorder/firstorderrecord',
        name: 'FirstOrderRecord',
        meta: {
          title: '首单购买记录',
          icon: 'goumaijilu'
        },
        component: () => import('_c/firstorder/firstorderrecord')
      }
    ]
  },
  {
    path: '/assembleactivity',
    name: 'Assembleactivity',
    meta: {
      title: '拼团管理',
      icon: 'pintuan'
    },
    component: Main,
    children: [
      {
        path: '/assembleactivity/assemblelist',
        name: 'AssembleList',
        meta: {
          title: '拼团列表',
          icon: 'pintuanliebiao1'
        },
        component: () => import('_c/assembleactivity/assemblelist')
      },
      {
        path: '/assembleactivity/assembledetail',
        name: 'AssembleDetail',
        meta: {
          title: '新增拼团活动',
          isDetail: 'AssembleList'
        },
        component: () => import('_c/assembleactivity/assembledetail')
      },
      {
        path: '/assembleactivity/assemblejoinrecord',
        name: 'AssembleJoinRecord',
        meta: {
          title: '拼团参与明细',
          icon: 'pintuancanyumingxi'
        },
        component: () => import('_c/assembleactivity/assemblejoinrecord')
      },
      {
        path: '/assembleactivity/assemblejoindetail',
        name: 'AssembleJoinDetail',
        meta: {
          title: '拼团详情',
          isDetail: 'AssembleJoinRecord'
        },
        component: () => import('_c/assembleactivity/assemblejoindetail')
      }
    ]
  },
  {
    path: '/complain',
    name: 'Complain',
    meta: {
      title: '投诉管理',
      icon: 'tousuguanli'
    },
    component: Main,
    children: [
      {
        path: '/complain/complaintype',
        name: 'ComplainType',
        meta: {
          title: '投诉类型',
          icon: 'tousuleixingguanli'
        },
        component: () => import('_c/complain/complaintype')
      },
      {
        path: '/complain/complainlist',
        name: 'ComplainList',
        meta: {
          title: '投诉列表',
          icon: 'tousuguanli'
        },
        component: () => import('_c/complain/complainlist')
      }
    ]
  },
  {
    path: '/active',
    name: 'Active',
    meta: {
      title: '活动管理',
      icon: 'activelist'
    },
    component: Main,
    children: [
      {
        path: '/contentmanage/activelist',
        name: 'ActiveList',
        meta: {
          title: '活动列表',
          icon: 'activelist'
        },
        component: () => import('_c/contentmanage/activelist')
      },
      {
        path: '/contentmanage/activedetail',
        name: 'ActiveDetail',
        meta: {
          title: '活动详情',
          icon: 'activelist',
          isDetail: 'ActiveList'
        },
        component: () => import('_c/contentmanage/activedetail')
      }
    ]
  },
  {
    path: '/version',
    name: 'Version',
    meta: {
      title: '小程序管理',
      icon: 'editionlist'
    },
    component: Main,
    children: [
      {
        path: '/xcxpublic/editionlist',
        name: 'EditionList',
        meta: {
          title: '小程序',
          icon: 'editionlist'
        },
        component: () => import('_c/xcxpublic/editionlist')
      },
      {
        path: '/xcxpublic/editiondetail',
        name: 'EditionDetail',
        meta: {
          title: '小程序详情',
          icon: 'editionlist',
          isDetail: 'EditionList'
        },
        component: () => import('_c/xcxpublic/editiondetail')
      }
    ]
  },
  {
    path: '/bargain',
    name: 'Bargain',
    meta: {
      title: '砍价管理',
      icon: 'kanjiaguanli'
    },
    redirect: { name: 'BargainList' },
    component: Main,
    children: [
      {
        path: '/bargain/bargainList',
        name: 'BargainList',
        meta: {
          title: '砍价列表',
          icon: 'kanjialiebiao'
        },
        component: () => import('_c/bargain/index')
      },
      {
        path: '/bargain/bargainDetail',
        name: 'BargainDetail',
        meta: {
          title: route => (`${route.query.id}` ? '砍价详情' : '添加砍价'),
          icon: 'kanjiaxiangqing',
          isDetail: 'BargainList'
        },
        component: () => import('_c/bargain/detail')
      },
      {
        path: '/bargain/bargainedList',
        name: 'BargainedList',
        meta: {
          title: '砍价参与明细',
          icon: 'canyukanjialiebiao'
        },
        component: () => import('_c/bargain/bargainedList')
      }
    ]
  },
  {
    path: '/task',
    name: 'Task',
    meta: {
      title: '任务管理',
      icon: 'renwuguanli'
    },
    redirect: { name: '' },
    component: Main,
    children: [
      {
        path: '/task/signin',
        name: 'SigninTask',
        meta: {
          title: '签到任务',
          icon: 'qiandaorenwu'
        },
        component: () => import('_c/task/sign_in/index')
      },
      {
        path: '/task/bind',
        name: 'BindTask',
        meta: {
          title: '绑定任务',
          icon: 'bangdingrenwu'
        },
        component: () => import('_c/task/bind/index')
      }
    ]
  },
  {
    path: '/offline_activity',
    name: 'OfflineActivityManage',
    meta: {
      title: '线下活动管理',
      icon: 'xianxiahuodongguanli'
    },
    redirect: { name: '' },
    component: Main,
    children: [
      {
        path: '/offline_activitys',
        name: 'OfflineActivitys',
        meta: {
          title: '线下活动列表',
          icon: 'liebiao1'
        },
        component: () => import('_c/offlineactivity/activity/index')
      },
      {
        path: '/offline_activity/users',
        name: 'OfflineActivityUsers',
        meta: {
          title: '线下活动用户列表',
          icon: 'qiandaorenwu'
        },
        component: () => import('_c/offlineactivity/user/index')
      },
      {
        path: '/offline_raffle',
        name: 'OfflineRaffle',
        meta: {
          title: '抽奖管理',
          icon: 'liebiao1'
        },
        component: () => import('_c/offlineactivity/activity/raffle')
      },
      {
        path: '/offline_raffle_prize',
        name: 'OfflineRafflePrize',
        meta: {
          title: '抽奖详情',
          icon: 'liebiao1',
          isDetail: 'OfflineRaffle'
        },
        component: () => import('_c/offlineactivity/activity/prize')
      },
      {
        path: '/offline_activitys_game',
        name: 'OfflineActivitysGame',
        meta: {
          title: '游戏管理',
          icon: 'liebiao1'
        },
        component: () => import('_c/offlineactivity/activity/game')
      },
      {
        path: '/offline_activitys_game_detail',
        name: 'GameDetail',
        meta: {
          title: '游戏编辑',
          icon: 'qiandaorenwu',
          isDetail: 'OfflineActivitysGame'
        },
        component: () => import('_c/offlineactivity/activity/gamedetail')
      },
      {
        path: '/offline_activitys_integral',
        name: 'OfflineActivitysIntegral',
        meta: {
          title: '线下活动-积分商城',
          icon: 'qiandaorenwu'
        },
        component: () => import('_c/offlineactivity/activity/integral')
      },
      {
        path: '/offline_activitys_integral_detail',
        name: 'IntegralDetail',
        meta: {
          title: '线下活动-积分商品详情',
          icon: 'qiandaorenwu'
        },
        component: () => import('_c/offlineactivity/activity/integraldetail')
      },
      {
        path: '/offline_activitys_my',
        name: 'OfflineActivitysMy',
        meta: {
          title: '我的线下活动列表',
          icon: 'wodeliebiao'
        },
        component: () => import('_c/offlineactivity/activity/emp')
      },
      {
        path: '/offline_activity_edit',
        name: 'OfflineActivityEdit',
        meta: {
          title: '线下活动详情',
          icon: 'qiandaorenwu'
        },
        component: () => import('_c/offlineactivity/activity/edit')
      },
      {
        path: '/offline_activity_emps',
        name: 'OfflineActivityEmps',
        meta: {
          title: '线下活动员工列表',
          icon: 'qiandaorenwu'
        },
        component: () => import('_c/offlineactivity/emp/index')
      },
      {
        path: '/offline_activity_codes',
        name: 'OfflineActivityCodes',
        meta: {
          title: '线下活动邀请码详情',
          icon: 'qiandaorenwu'
        },
        component: () => import('_c/offlineactivity/emp/code')
      },
      {
        path: '/offline_activity_codes_my',
        name: 'OfflineActivityCodesMy',
        meta: {
          title: '我的线下活动邀请码详情',
          icon: 'qiandaorenwu'
        },
        component: () => import('_c/offlineactivity/emp/code1')
      },
      {
        path: '/seckill_goods',
        name: 'SeckillGoods',
        meta: {
          title: '线下活动-秒杀商品',
          icon: 'miaoshashangpin'
        },
        component: () => import('_c/seckillgoods/seckillgoods')
      },
      {
        path: '/seckill_goods_detail',
        name: 'SeckillGoodsDetail',
        meta: {
          title: '线下活动-秒杀商品详情',
          icon: 'tianjiamiaoshashangpin',
          isDetail: 'SeckillGoods'
        },
        component: () => import('_c/seckillgoods/seckillgoodsdetail')
      },
      {
        path: '/assemble_goods',
        name: 'AssembleGoodsList',
        meta: {
          title: '线下活动-拼团商品',
          icon: 'pingtuanshangpin'
        },
        component: () => import('_c/assemblegoods/assemblegoodslist')
      },
      {
        path: '/assemble_goods_detail',
        name: 'AssembleGoodsDetail',
        meta: {
          title: '线下活动-拼团商品详情',
          icon: 'tianjiapintuanshangpin'
        },
        component: () => import('_c/assemblegoods/assemblegoodsdetail')
      },
      {
        path: '/assemble_goods_join_detail',
        name: 'AssembleGoodsJoinDetail',
        meta: {
          title: '拼团明细详情',
          icon: 'pintuanmingxixiangqing'
        },
        component: () => import('_c/assemblegoods/assemblegoodsjoindetail')
      },
      {
        path: '/consumption_rank',
        name: 'ConsumptionRankList',
        meta: {
          title: '消费排名',
          icon: 'xiaofeipaiming'
        },
        component: () => import('_c/consumptionrank/consumptionranklist')
      },
      {
        path: '/photowall_detail',
        name: 'PhotoWallDetail',
        meta: {
          title: '照片墙',
          icon: 'zhaopianqiang'
        },
        component: () => import('_c/offlineactivity/photo_wall/index.vue')
      }
    ]
  },
  {
    path: '/registrationFee',
    name: 'RegistrationFee',
    meta: {
      title: '挂号管理',
      icon: 'xianxiahuodongguanli'
    },
    redirect: { name: '' },
    component: Main,
    children: [
      {
        path: '/contentmanage/registrationorderlist',
        name: 'Registrationorderlist',
        meta: {
          title: '挂号记录',
          icon: 'yiyuan'
        },
        component: () => import('_c/contentmanage/registrationorderlist')
      },
      {
        path: '/contentmanage/registrationFeeDetail',
        name: 'RegistrationFeeDetail',
        meta: {
          title: '挂号费详情',
          icon: 'yiyuan'
        },
        component: () => import('_c/contentmanage/registrationFeeDetail')
      },
      {
        path: '/contentmanage/registrationfeelist',
        name: 'Registrationfeelist',
        meta: {
          title: '挂号费设置',
          icon: 'zixun'
        },
        component: () => import('_c/contentmanage/registrationfeelist')
      }
    ]
  },
  {
    path: '/departmentlist',
    name: 'Departmentlist',
    meta: {
      title: '科室管理',
      icon: 'xianxiahuodongguanli'
    },
    redirect: { name: '' },
    component: Main,
    children: [
      {
        path: '/contentmanage/departmentlist',
        name: 'Departmentlist',
        meta: {
          title: '科室列表',
          icon: 'yiyuan'
        },
        component: () => import('_c/contentmanage/departmentlist')
      }
    ]
  },
  {
    path: '/projectList',
    name: 'ProjectList',
    meta: {
      title: '项目券管理',
      icon: 'xianxiahuodongguanli'
    },
    component: Main,
    children: [{
      path: '/project/projectList',
      name: 'ProjectList',
      meta: {
        title: '项目券管理',
        icon: 'xianxiahuodongguanli'
      },
      component: () => import('_c/project/projectList')
    }, {
      path: '/project/projectDetail',
      name: 'ProjectDetail',
      meta: {
        title: '项目详情',
        icon: 'xianxiahuodongguanli'
      },
      component: () => import('_c/project/projectDetail')
    }, {
      path: '/project/projectUsers',
      name: 'ProjectUsers',
      meta: {
        title: '项目领取详情',
        icon: 'xianxiahuodongguanli'
      },
      component: () => import('_c/project/projectUsers')
    }]
  },
  {
    path: '/QRcode',
    name: 'QRcode',
    meta: {
      title: '二维码管理',
      icon: 'pintuanliebiao1'
    },
    component: Main,
    children: [
      {
        path: '/QRcode',
        name: 'QRcode',
        meta: {
          title: '二维码管理',
          icon: 'pintuanliebiao1'
        },
        component: () => import('_c/contentmanage/QRcode')
      }
    ]
  },
  {
    path: '/channel',
    name: 'Channel',
    meta: {
      title: '渠道管理',
      icon: 'piliangcaozuo'
    },
    component: Main,
    children: [
      {
        path: '/Channel',
        name: 'Channel',
        meta: {
          title: '渠道管理',
          icon: 'piliangcaozuo'
        },
        component: () => import('_c/contentmanage/channel')
      }
    ]
  },
  {
    path: '/item',
    name: 'Items',
    meta: {
      title: '预约管理',
      icon: 'jifendingdan'
    },
    component: Main,
    children: [
      {
        path: '/item/item',
        name: 'Item',
        meta: {
          title: '项目列表',
          icon: 'jifendingdan'
        },
        component: () => import('_c/item/item')
      },
      {
        path: '/item/appointmentDetail',
        name: 'AppointmentDetail',
        meta: {
          title: '项目列表',
          icon: 'jiaoyimingxi'
        },
        component: () => import('_c/item/appointmentDetail')
      },
      {
        path: '/item/itemDetail',
        name: 'ItemDetail',
        meta: {
          title: '项目编辑',
          icon: 'jiaoyimingxi'
        },
        component: () => import('_c/item/itemDetail')
      }
    ]
  }
]
/**
 * iview-admin中meta除了原生参数外可配置的参数:
 * meta: {
 *  title: { String|Number|Function }
 *         显示在侧边栏、面包屑和标签栏的文字
 *         使用'{{ 多语言字段 }}'形式结合多语言使用，例子看多语言的路由配置;
 *         可以传入一个回调函数，参数是当前路由对象，例子看动态路由和带参路由
 *  hideInBread: (false) 设为true后此级路由将不会出现在面包屑中，示例看QQ群路由配置
 *  hideInMenu: (false) 设为true后在左侧菜单不会显示该页面选项
 *  notCache: (false) 设为true后页面在切换标签后不会缓存，如果需要缓存，无需设置这个字段，而且需要设置页面组件name属性和路由配置的name一致
 *  access: (null) 可访问该页面的权限数组，当前路由设置的权限会影响子路由
 *  icon: (-) 该页面在左侧菜单、面包屑和标签导航处显示的图标，如果是自定义图标，需要在图标名称前加下划线'_'
 *  beforeCloseName: (-) 设置该字段，则在关闭当前tab页时会去'@/router/before-close.js'里寻找该字段名对应的方法，作为关闭前的钩子函数
 * =======
 *  showAlways: true  如果子集还有children，设置这样就会在菜单中显示该子集
 * }
 */



// WEBPACK FOOTER //
// ./src/router/routers.js